export const DISABLED_ORDER_FORM_PROVIDER_SLUGS = ['emil_frey', 'vehicle_logistics'];

const normalizeSlug = (value: any): string => {
    return `${value || ''}`.trim().toLowerCase();
};

export const isOrderFormProviderDisabled = (provider: any): boolean => {
    const slug = normalizeSlug(provider?.slug);
    return DISABLED_ORDER_FORM_PROVIDER_SLUGS.includes(slug);
};

export const toOrderFormProviderOptions = (providers: any[] = []): any[] => {
    return (providers || []).map((provider: any) => ({
        ...provider,
        key: provider.key ?? provider.id,
        disabled: isOrderFormProviderDisabled(provider),
    }));
};

export const getDefaultProviderOption = (providers: any[] = []): any | null => {
    return (providers || []).find((provider: any) => normalizeSlug(provider?.slug) === 'default') || null;
};
